import {FieldRoot} from '../../components/form/field-root.js'
import {useFieldContext} from '../../integrations/form/index.js'
import {CheckboxCard as ChakraCheckboxCard, CheckboxCardRootProps, Float, Icon} from '@chakra-ui/react'
import {IconType} from 'react-icons/lib'

interface Props extends CheckboxCardRootProps {
  label: string
  description?: string
  icon?: IconType
}

export function CheckboxCard({label, description, required, icon, ...props}: Props) {
  const field = useFieldContext<boolean>()

  return (
    <FieldRoot required={required}>
      <ChakraCheckboxCard.Root
        size="md"
        name={field.name}
        checked={field.state.value}
        onCheckedChange={changes => field.handleChange(Boolean(changes.checked))}
        align="center"
        {...props}
      >
        <ChakraCheckboxCard.HiddenInput />
        <ChakraCheckboxCard.Control>
          <ChakraCheckboxCard.Content>
            <Icon fontSize="2xl" mb="2">
              {icon?.({size: 24})}
            </Icon>
            <ChakraCheckboxCard.Label>{label}</ChakraCheckboxCard.Label>
            {description && <ChakraCheckboxCard.Description>{description}</ChakraCheckboxCard.Description>}
          </ChakraCheckboxCard.Content>
          <Float placement="top-end" offset="6">
            <ChakraCheckboxCard.Indicator />
          </Float>
        </ChakraCheckboxCard.Control>
      </ChakraCheckboxCard.Root>
    </FieldRoot>
  )
}
